module.exports = __webpack_public_path__ + "static/media/paymentDetails.f7e6d1b7.svg";